export default __webpack_public_path__ + "static/media/linked-in-logo.8cda13fe.svg";